import React, { Component } from 'react';
import YouTube from 'react-youtube';

import Header from './components/Header';
import { getLatestVideo } from './utils/api.js';

class App extends Component {
  constructor() {
    super();
    this.state = {
      latestVideo: '',
    };
  }

  async componentWillMount() {
    const latestVideo = await getLatestVideo();

    if (latestVideo) {
      this.setState({ latestVideo });
    }
  }

  onReady = e => {
    setTimeout(() => {
      e.target.playVideo();
    }, 100);
  };

  render() {
    const opts = {
      height: '768',
      width: '1024',
      playerVars: {
        autoplay: 1,
        modestbranding: 1,
        playsinline: 1,
        showinfo: 0,
      },
    };

    return (
      <div className="App">
        <Header />
        <YouTube videoId={this.state.latestVideo} opts={opts} onReady={this.onReady} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js